import { useState } from "react";
import { FormInput } from "../../components/Forms/FormInput";
import { FaDollarSign } from "react-icons/fa6";
import { helpers } from "../../utils/helpers";
import { ClipLoader } from "react-spinners";
import { colors } from "../../utils/colors";

export const Transfer = () => {
    const [amount, setAmount] = useState<string>("0");
    const [loading, setLoading] = useState<boolean>(false);

    const submit = () => {
        setLoading(true);
        setTimeout(() => {
            console.log("submitting");
            setLoading(false);
        }, helpers.RandomNumber(2000, 5000));
    };
    return (
        <div className="transfer-container">
            <h1
                style={{
                    textAlign: "center"
                }}
            >
                Transfer
            </h1>

            <div className="transfer-amount-container">
                <form
                    name=""
                    className="transfer-form"
                    onSubmit={e => {
                        e?.preventDefault();
                        submit();
                    }}
                >
                    <div className="transfer-amount-input-container">
                        <FormInput
                            id="transfer-amount-input"
                            type="text"
                            onChange={e => setAmount(e.target.value)}
                            value={amount}
                            label={""}
                            required={true}
                            icon={<FaDollarSign size={60} />}
                        />
                    </div>

                    <select name="banks" id="bank-select" className="transfer-form-dropdown">
                        <option value="">Please choose a bank</option>
                        <option id="option-1" value="option-1">
                            Wells Cargo - 1234
                        </option>
                        <option id="option-2" value="option-1">
                            Bank of Uhmerica - 5678
                        </option>
                    </select>

                    {!loading && <input type="submit" value={"Transfer"} className="transfer-button" />}

                    {loading && (
                        <div>
                            <ClipLoader color={colors.orange} />
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};
